import { Instance } from 'mobx-state-tree';
import React, { useMemo, useRef } from 'react';

import PharmacySelection from '../../dropdownSelection/PharmacySelection';
import { Pharmacy } from '../../../../store/models/Pharmacy';
import { PharmacyDetails } from '../../../../store/models/PharmacyDetails';
import { Group } from '../../../../store/models';

interface LazyPharmacySelectionForCalendarProps {
  pharmacyId: number | undefined;
  onPharmacyChange: ((selectedOption: any) => void) | undefined;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  getGroupName: (pharmacy: Instance<typeof Pharmacy>) => string;
  lazy?: boolean;
}

export const LazyPharmacySelectionForCalendar = ({
  pharmacyId,
  pharmacyList,
  onPharmacyChange,
  getGroupName,
  lazy,
}: LazyPharmacySelectionForCalendarProps) => {
  const detailedPharmacies = useMemo(() => {
    return pharmacyList.map((simplePh) => {
      const ph = simplePh as Instance<typeof PharmacyDetails>;
      if (ph.groupId) ph.setGroup({ groupId: ph.groupId, name: getGroupName(simplePh) } as Instance<typeof Group>);
      return ph;
    });
  }, [pharmacyList, getGroupName]);

  const lastKnownPharmacyRef = useRef<Instance<typeof PharmacyDetails> | undefined>(undefined);

  const pharmacyDetails = useMemo(() => {
    if (pharmacyId === undefined) {
      lastKnownPharmacyRef.current = undefined;
      return undefined;
    }
    const simplePh = pharmacyList.find((ph) => ph.pharmacyId === pharmacyId);
    if (simplePh === undefined) return lastKnownPharmacyRef.current;
    const ph = simplePh as Instance<typeof PharmacyDetails>;
    if (ph.groupId) ph.setGroup({ groupId: ph.groupId, name: getGroupName(simplePh) } as Instance<typeof Group>);
    lastKnownPharmacyRef.current = ph;
    return ph;
  }, [pharmacyList, getGroupName, pharmacyId]);

  return (
    <div style={{ marginRight: '20px' }}>
      <PharmacySelection
        pharmacySelected={pharmacyDetails}
        pharmacyList={detailedPharmacies}
        onChange={onPharmacyChange}
        showLevel
        showGroup
        showAddress
        renderNoItemsOnEmptyFilter={lazy}
      />
    </div>
  );
};
